<template>
  <ion-app>
    <div class="slides-wrapper">
      <v-touch @swipeleft="gotoSlide('next')" @swiperight="gotoSlide('previous')">
        <div class="slides-logo">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
          />
        </div>
        <div v-if="activeSlide === 'first'" class="slides-illustration" @click="gotoSlide('next')">
          <p class="slides-message">{{ firstSlide.text }}</p>
          <img src="Screenshot1.png" />
        </div>
        <div v-if="activeSlide === 'second'" class="slides-illustration" @click="gotoSlide('next')">
          <p class="slides-message">{{ secondSlide.text }}</p>
          <img src="Screenshot2.png" />
        </div>
        <div v-if="activeSlide === 'third'" class="slides-illustration" @click="gotoSlide('next')">
          <p class="slides-message">{{ thirdSlide.text }}</p>
          <img src="Screenshot3.png" />
        </div>
        <div v-if="activeSlide === 'fourth'" class="slides-illustration" @click="gotoSlide('next')">
          <p class="slides-message">{{ fourthSlide.text }}</p>
          <img src="Screenshot4.png" />
        </div>
        <div v-if="activeSlide === 'fifth'" class="slides-illustration" @click="gotoSlide('next')">
          <p class="slides-message">{{ fifthSlide.text }}</p>
          <img src="Screenshot5.png" />
        </div>
        <div class="slides-bottom-menu">
          <div class="slides-icon" :class="firstSlide.icon" @click="gotoSlide('first')"></div>
          <div class="slides-icon" :class="secondSlide.icon" @click="gotoSlide('second')"></div>
          <div class="slides-icon" :class="thirdSlide.icon" @click="gotoSlide('third')"></div>
          <div class="slides-icon" :class="fourthSlide.icon" @click="gotoSlide('fourth')"></div>
          <div class="slides-icon" :class="fifthSlide.icon" @click="gotoSlide('fifth')"></div>
        </div>
      </v-touch>
    </div>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div class="logo">
          <ion-img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
          ></ion-img>
        </div>
        <div class="welcome-buttons">
          <div class="access-button mr-1" @click="gotoSignup">Cadastrar</div>
          <div class="access-button-outline ml-1" @click="gotoLogin">Entrar</div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// moment
import moment from "moment";
moment.locale("pt-br");
// services
import authService from "@/services/auth/auth.js";
// component
export default {
  name: "WelcomePage",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      socialButtonsClass: "",
      facebookClass: "",
      slides: true,
      activeSlide: "first",
      firstSlide: {
        icon: "bg-green",
        text: "Dieta personalizada com menu completo toda semana"
      },
      secondSlide: {
        icon: "bg-dark",
        text: "Milhares de receitas saudáveis, práticas e super bem explicadas"
      },
      thirdSlide: {
        icon: "bg-dark",
        text:
          "Lista de compras inteligente pra você saber direitinho o que precisa"
      },
      fourthSlide: {
        icon: "bg-dark",
        text: "Encontre a receita perfeita para o que tem na sua geladeira"
      },
      fifthSlide: {
        icon: "bg-dark",
        text: "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
      },
      fadeClass: ""
    };
  },
  methods: {
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    closeSlides() {
      this.slides = false;
    },
    fadeSlide() {
      const instance = this;
      instance.fadeClass = "slide-fade";
    },
    gotoSlide(slide) {
      const instance = this;
      this.fadeSlide();
      function switchToFirst(instance) {
        instance.activeSlide = "first";
        instance.firstSlide = {
          icon: "bg-green",
          text: "Dieta personalizada com menu completo toda semana"
        };
        instance.secondSlide = {
          icon: "bg-dark",
          text:
            "Milhares de receitas saudáveis, práticas e super bem explicadas"
        };
        instance.thirdSlide = {
          icon: "bg-dark",
          text:
            "Lista de compras inteligente pra você saber direitinho o que precisa"
        };
        instance.fourthSlide = {
          icon: "bg-dark",
          text: "Encontre a receita perfeita para o que tem na sua geladeira"
        };
        instance.fifthSlide = {
          icon: "bg-dark",
          text:
            "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
        };
      }

      function switchToSecond(instance) {
        instance.activeSlide = "second";
        instance.firstSlide = {
          icon: "bg-dark",
          text: "Dieta personalizada com menu completo toda semana"
        };
        instance.secondSlide = {
          icon: "bg-green",
          text:
            "Milhares de receitas saudáveis, práticas e super bem explicadas"
        };
        instance.thirdSlide = {
          icon: "bg-dark",
          text:
            "Lista de compras inteligente pra você saber direitinho o que precisa"
        };
        instance.fourthSlide = {
          icon: "bg-dark",
          text: "Encontre a receita perfeita para o que tem na sua geladeira"
        };
        instance.fifthSlide = {
          icon: "bg-dark",
          text:
            "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
        };
      }

      function switchToThird(instance) {
        instance.activeSlide = "third";
        instance.firstSlide = {
          icon: "bg-dark",
          text: "Dieta personalizada com menu completo toda semana"
        };
        instance.secondSlide = {
          icon: "bg-dark",
          text:
            "Milhares de receitas saudáveis, práticas e super bem explicadas"
        };
        instance.thirdSlide = {
          icon: "bg-green",
          text:
            "Lista de compras inteligente pra você saber direitinho o que precisa"
        };
        instance.fourthSlide = {
          icon: "bg-dark",
          text: "Encontre a receita perfeita para o que tem na sua geladeira"
        };
        instance.fifthSlide = {
          icon: "bg-dark",
          text:
            "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
        };
      }

      function switchToFourth(instance) {
        instance.activeSlide = "fourth";
        instance.firstSlide = {
          icon: "bg-dark",
          text: "Dieta personalizada com menu completo toda semana"
        };
        instance.secondSlide = {
          icon: "bg-dark",
          text:
            "Milhares de receitas saudáveis, práticas e super bem explicadas"
        };
        instance.thirdSlide = {
          icon: "bg-dark",
          text:
            "Lista de compras inteligente pra você saber direitinho o que precisa"
        };
        instance.fourthSlide = {
          icon: "bg-green",
          text: "Encontre a receita perfeita para o que tem na sua geladeira"
        };
        instance.fifthSlide = {
          icon: "bg-dark",
          text:
            "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
        };
      }

      function switchToFifth(instance) {
        instance.activeSlide = "fifth";
        instance.firstSlide = {
          icon: "bg-dark",
          text: "Dieta personalizada com menu completo toda semana"
        };
        instance.secondSlide = {
          icon: "bg-dark",
          text:
            "Milhares de receitas saudáveis, práticas e super bem explicadas"
        };
        instance.thirdSlide = {
          icon: "bg-dark",
          text:
            "Lista de compras inteligente pra você saber direitinho o que precisa"
        };
        instance.fourthSlide = {
          icon: "bg-dark",
          text: "Encontre a receita perfeita para o que tem na sua geladeira"
        };
        instance.fifthSlide = {
          icon: "bg-green",
          text:
            "Monitore seu progresso, acumule conquistas e atinja seu objetivo"
        };
      }
      if (slide === "first") {
        switchToFirst(instance);
      } else if (slide === "second") {
        switchToSecond(instance);
      } else if (slide === "third") {
        switchToThird(instance);
      } else if (slide === "fourth") {
        switchToFourth(instance);
      } else if (slide === "fifth") {
        switchToFifth(instance);
      } else if (slide === "previous") {
        if (instance.activeSlide === "first") {
          //
        } else if (instance.activeSlide === "second") {
          switchToFirst(instance);
        } else if (instance.activeSlide === "third") {
          switchToSecond(instance);
        } else if (instance.activeSlide === "fourth") {
          switchToThird(instance);
        } else if (instance.activeSlide === "fifth") {
          switchToFourth(instance);
        }
      } else if (slide === "next") {
        if (instance.activeSlide === "first") {
          switchToSecond(instance);
        } else if (instance.activeSlide === "second") {
          switchToThird(instance);
        } else if (instance.activeSlide === "third") {
          switchToFourth(instance);
        } else if (instance.activeSlide === "fourth") {
          switchToFifth(instance);
        } else {
          //
        }
      } else {
        //
      }
    },
    gotoSignup() {
      this.$router.push({
        name: "Sign Up"
      });
    },
    gotoLogin() {
      this.$router.push({
        name: "Login"
      });
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--ion-color-grey) !important;
}

.logo {
  position: absolute;
  top: var(--standard-padding-top);
  left: 50%;
  transform: translate(-50%);
  z-index: 999;
}

.logo img {
  height: 60px;
  width: auto;
}

.slides-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  height: 85vh;
  background: white;
  border-radius: 0 0 40px 40px;
  z-index: 1000;
}

.slides-logo {
  display: flex;
  justify-content: center;
  margin-top: var(--standard-padding-top);
}

.slides-logo img {
  height: 40px !important;
  width: auto;
}

.slides-illustration {
  text-align: center;
  position: absolute;
  top: calc(60px + var(--standard-padding-top));
  left: 50%;
  transform: translate(-50%);
  height: 90vh;
  width: 100%;
  z-index: 1000;
}

.slides-illustration img {
  margin: 0 auto;
  height: calc(64% - var(--standard-padding-top));
  width: auto;
  z-index: 1005;
}

.slides-message {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: calc(100% - 15vw);
  font-size: 1.25rem;
  margin-bottom: 20px;
  color: var(--ion-color-primary);
  z-index: 1001;
  font-weight: 400 !important;
  text-transform: uppercase !important;
}

@media (max-width: 350px) {
  .slides-message {
    font-size: 1rem;
  }
  .slides-illustration img {
    height: calc(60% - var(--standard-padding-top));
  }
}

@media (min-width: 600px) {
  .slides-message {
    font-size: 2rem;
  }
  .slides-illustration {
    top: calc(80px + var(--standard-padding-top));
  }
  .slides-illustration img {
    height: calc(68% - var(--standard-padding-top));
  }
}

.slides-bottom-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translate(-50%);
  z-index: 1001;
}

.slides-icon {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 10px;
}

.slide-fade {
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}

v-touch {
  height: 100vh;
  width: 100vw;
}

.welcome-buttons {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  text-align: center;
  position: absolute;
  bottom: 5vh;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  padding-left: 10vw;
  padding-right: 10vw;
  z-index: 1020;
}

.access-button {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 40px;
  max-width: var(--max-width);
  width: 100%;
  border-radius: 30px;
  cursor: pointer !important;
  background: var(--ion-color-primary);
  color: white;
}

.access-button-outline {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 40px;
  max-width: var(--max-width);
  width: 100%;
  border-radius: 30px;
  cursor: pointer !important;
  border: 1px solid white;
  color: white;
}
</style>